/* Smilab independent app bridge. Cart requests, variant IDs, line properties and SEAL selling plans are never rewritten. */
(function(){
 'use strict';if(window.__smilabIndependentBridge)return;window.__smilabIndependentBridge=true;
 var internal=false,timer=null;
 var endpoints=['/cart/add','/cart/add.js','/cart/change','/cart/change.js','/cart/update','/cart/update.js','/cart/clear','/cart/clear.js'];
 window.__markInternalCartCall=function(){internal=true;};
 window.__unmarkInternalCartCall=function(){internal=false;};
 function isWrite(input,method){
  if(String(method||'GET').toUpperCase()==='GET')return false;
  try{var url=new URL(typeof input==='string'?input:input.url,location.href);
   return url.origin===location.origin&&endpoints.some(function(path){return url.pathname===path||url.pathname.endsWith(path);});
  }catch(error){return false;}
 }
 function paint(count){
  document.querySelectorAll('.sl-header__cart').forEach(function(link){
   var badge=Array.from(link.children).find(function(element){return element.tagName==='SPAN'&&!element.classList.contains('visually-hidden');});
   if(count>0){if(!badge){badge=document.createElement('span');link.appendChild(badge);}badge.textContent=String(count);}
   else if(badge)badge.remove();
  });
 }
 var originalFetch=window.fetch;
 function refreshCount(){
  var base=window.routes&&window.routes.cart_url||'/cart';
  originalFetch.call(window,base+'.js',{headers:{Accept:'application/json'}})
  .then(function(response){return response.json();})
  .then(function(cart){paint(Number(cart.item_count)||0);}).catch(function(){});
 }
 function announce(){
  clearTimeout(timer);timer=setTimeout(function(){
   if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined')
    publish(PUB_SUB_EVENTS.cartUpdate,{source:'smilab-independent-app-bridge'});
   else{var items=document.querySelector('cart-drawer-items');if(items&&typeof items.onCartUpdate==='function')items.onCartUpdate();}
   refreshCount();
  },300);
 }
 window.fetch=function(input,init){
  var method=init&&init.method||input&&input.method||'GET';
  var changed=isWrite(input,method),own=internal;if(changed)internal=false;
  var result=originalFetch.apply(this,arguments);if(!changed)return result;
  return result.then(function(response){if(response.ok&&!own)response.clone().json().catch(function(){return null;}).then(announce);return response;});
 };
 var originalOpen=XMLHttpRequest.prototype.open,originalSend=XMLHttpRequest.prototype.send;
 XMLHttpRequest.prototype.open=function(method,url){this.__smCartRequest=isWrite(String(url),method);return originalOpen.apply(this,arguments);};
 XMLHttpRequest.prototype.send=function(){
  var own=internal;if(this.__smCartRequest){internal=false;if(!own)this.addEventListener('load',function(){if(this.status>=200&&this.status<300)announce();},{once:true});}
  return originalSend.apply(this,arguments);
 };
 window.smilabSyncCartCount=paint;
 function install(){
  var store=document.getElementById('smilab-cart-state');
  if(store)new MutationObserver(function(){
   var badge=store.querySelector('.cart-count-bubble');paint(badge?parseInt(badge.textContent,10)||0:0);
  }).observe(store,{childList:true,subtree:true,characterData:true});
  document.addEventListener('click',function(event){
   var target=event.target.closest&&event.target.closest('.sl-header__cart');
   if(!target||event.defaultPrevented)return;
   var drawer=document.querySelector('cart-drawer');
   if(drawer&&typeof drawer.open==='function'){event.preventDefault();drawer.open(target);}
  });
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')
   subscribe(PUB_SUB_EVENTS.cartUpdate,function(event){
    if(event&&event.cartData)paint(Number(event.cartData.item_count)||0);else refreshCount();
   });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',install,{once:true});else install();
})();
